import {branch, mapProps, renderNothing} from 'recompose'

import compose from 'lodash/flowRight'
import type {ComponentType} from 'react'
import {connect} from 'react-redux'

import type {DialogProps} from '../../../../hocs/withDialogContainer'
import withDialogContainer from '../../../../hocs/withDialogContainer'
import type {State} from '../../../../reducers/types'
import {getBuildType, getIsSakuraUI, getProject} from '../../../../selectors'
import {DialogType, stringifyId} from '../../../../types'
import {getProblemOccurrencesById} from '../../BuildProblems/BuildProblems.selectors'
import InvestigationHistoryPopup from '../InvestigationHistoryPopup/InvestigationHistoryPopup'

import type {
  OwnProps,
  OwnPropsDummy,
  StateProps,
} from './BuildProblemInvestigationHistoryPopup.types'

const mapStateToProps: (arg0: State, arg1: OwnProps) => StateProps = (
  state,
  {problemOccurrenceId},
) => {
  const problemOccurrence = getProblemOccurrencesById(state, problemOccurrenceId)
  const buildTypeId = problemOccurrence?.build?.buildTypeId
  const buildType = getBuildType(state, buildTypeId)
  const project = getProject(state, buildType?.projectId)
  return {
    buildTypeId,
    projectId: buildType?.projectId,
    projectInternalId: project?.internalId,
    problemId: problemOccurrence?.problem?.id,
    problemName: problemOccurrence?.details,
    isSakuraUI: getIsSakuraUI(state),
  }
}

export const BuildProblemInvestigationHistoryPopupDummy: ComponentType<OwnPropsDummy> = compose(
  withDialogContainer(DialogType.INVESTIGATION_HISTORY, (state, props: OwnPropsDummy) =>
    stringifyId(props.problemOccurrenceId),
  ),
  mapProps(
    ({
      buildId,
      problemName,
      problemId,
      problemOccurrenceId,
      ...restProps
    }: DialogProps<OwnPropsDummy>) => ({
      ...restProps,
      subTitle: `Problem name – ${problemName ?? 'Unknown'}`,
      locator: `projectId=${stringifyId(restProps.projectId)}&BuiPro${stringifyId(
        problemId,
      )}=${stringifyId(buildId)}`,
    }),
  ),
  branch((props: DialogProps<OwnPropsDummy>) => !props.isOpened, renderNothing),
)(InvestigationHistoryPopup)

export default connect(
  mapStateToProps,
  {},
)(BuildProblemInvestigationHistoryPopupDummy) as ComponentType<OwnProps>
